import {
  Colors,
  MediaQuery,
  skeletonFadeAnimation,
  TextSkeleton,
  Theme,
  Image,
  H3Heavy,
} from '@pelando/components';
import styled from 'styled-components';

export type StoreSkeletonProps = {
  animate?: boolean;
};

export const StorePageHeaderContainer = styled.div`
  display: flex;
  min-height: 136px;
  background-color: rgb(${Theme.colors.Juliet});
`;

export const StorePageHeader = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    display: grid;
    grid-template-columns: 300px 1fr;
    grid-template-areas: 'unknow title';
    grid-column-gap: 24px;
    margin: auto;
    padding: 16px 32px;
  }
`;

export const StoreTitleContainer = styled.div`
  grid-area: title;
  display: flex;
  align-items: center;
  max-width: 970px;
`;

export const StoreImage = styled(Image)`
  && {
    width: 120px;
    height: 120px;
    border-radius: 4px;
  }
  border: 1px solid rgb(${Theme.colors.Golf});
  background-color: rgb(${Colors.White});

  && img {
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    width: 148px;
    height: 148px;
  }

  body[data-theme='DARK'] & {
    border: unset;
  }
`;

export const StoreImageButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StoreTitleSkeletonContainer = styled.div`
  grid-area: title;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 970px;
  height: 100%;
`;

export const StoreImageSkeleton = styled.div<StoreSkeletonProps>`
  min-width: 120px;
  min-height: 120px;
  margin-right: 8px;
  ${skeletonFadeAnimation}
  border-radius: 8px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    min-width: 148px;
    min-height: 148px;
  }
`;

export const Title = styled.h1`
  && {
    color: rgb(${Theme.colors.Alpha});
    margin-bottom: 12px;
    margin-left: 8px;
    ${H3Heavy}
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    ${H3Heavy}
    margin-bottom: 0;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  width: 100%;
`;

export const SubtitleSkeleton = styled(TextSkeleton)`
  height: 20px;
  max-width: 137px;
  border-radius: 8px;
  width: 100%;

  @media ${MediaQuery.SCREEN_MD_UP} {
    display: none;
  }
`;

export const TitleSkeleton = styled(TextSkeleton)`
  margin-bottom: 12px;
  width: 100%;
  height: 20px;
  max-width: 208px;
  border-radius: 8px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    margin-bottom: 0;
    max-width: 680px;
    height: 38px;
  }
`;
